import moment from "moment";
import React from "react";
import TimePicker from "../TimePicker";
import { formatTimeOfPerformance, isEarlyShow } from "utilities/showDateUtils";
import { ShowDatePickerProps } from "./models";
import SingleShowDatePicker from "./SingleShowDatepicker";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

const NotAllDayDatePickers = ({ showDates, onDatesChange }: ShowDatePickerProps) => {

  const onStartDateChange = (startDisplayDate: moment.Moment) => {
    let newEndDisplayDate = showDates.endDisplayDate;

    // When the start date changes (e.g. 2 days later than the previous start date), the end date should shift by the same amount (e.g. 2 days later than the previous end date)
    const startEndDifference = startDisplayDate.diff(showDates.startDisplayDate, "milliseconds");
    newEndDisplayDate = newEndDisplayDate.clone().add(startEndDifference, "milliseconds");

    const isInTheNightOf = isEarlyShow(startDisplayDate);

    onDatesChange({
      startDisplayDate,
      endDisplayDate: newEndDisplayDate,

      mode: isInTheNightOf ? "hasTimeStartsInNight" : "hasTime",
      timeOfPerformance: formatTimeOfPerformance(startDisplayDate, newEndDisplayDate)
    });
  };

  const onEndDateChange = (newDate: moment.Moment) => {
    onDatesChange({
      startDisplayDate: showDates.startDisplayDate,
      endDisplayDate: newDate,

      timeOfPerformance: formatTimeOfPerformance(showDates.startDisplayDate, newDate),

      mode: showDates.mode
    });
  };

  const onTimeStartChange = (newTime: moment.Moment) => {
    const newDate = showDates.startDisplayDate.clone();
    newDate.hour(newTime.hour());
    newDate.minute(newTime.minute());

    onStartDateChange(newDate);
  };

  const onTimeEndChange = (newTime: moment.Moment) => {
    const newDate = showDates.endDisplayDate.clone();
    newDate.hour(newTime.hour());
    newDate.minute(newTime.minute());
    onEndDateChange(newDate);
  };

  const onIsInTheNightChanged = (_, checked) => {
    onDatesChange({
      startDisplayDate: showDates.startDisplayDate,
      endDisplayDate: showDates.endDisplayDate,
      timeOfPerformance: formatTimeOfPerformance(showDates.startDisplayDate, showDates.endDisplayDate),
      mode: checked ? "hasTimeStartsInNight" : "hasTime"
    });
  };

  return <>
    {isEarlyShow(showDates.startDisplayDate) && <div className="margin-right-small">
      <Checkbox
        label={RESX.DateTime.InTheNightOf}
        checked={showDates.mode === "hasTimeStartsInNight"}
        onChange={onIsInTheNightChanged}
      />
    </div>}
    <div className="flex gap-small">
      <div>
        <SingleShowDatePicker
          validatorKey="showStartDate"
          onDateChange={onStartDateChange}
          value={showDates.startDisplayDate}
        />
      </div>
      <div>
        <TimePicker value={showDates.startDisplayDate} onChange={onTimeStartChange} step={"QuarterHourly"} />
      </div>
    </div>

    <div className="margin-right-small">
      {RESX.DateTime.UntilAndIncludingAbbreviated}
    </div>

    <div className="flex gap-small">
      <div>
        <SingleShowDatePicker
          validatorKey="showEndDate"
          onDateChange={onEndDateChange}
          value={showDates.endDisplayDate}
        />
      </div>
      <div>
        <TimePicker value={showDates.endDisplayDate} onChange={onTimeEndChange} step={"QuarterHourly"} />
      </div>
    </div>
  </>;
};

export default NotAllDayDatePickers;